<template>
  <el-form ref="form" :model="formData" :rules="rules">
    <el-row :gutter="20">
      <el-col :xs="{span: 24}" :sm="{span: 24}" :md="{span: 24}" :lg="{span: 24}">
        <el-form-item :label="$l('form_label_attribute_type')||'属性类型'" prop="resAttributeType">
          <el-input v-model="formData.resAttributeType" :disabled="disabled" size="medium"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="{span: 24}" :sm="{span: 24}" :md="{span: 24}" :lg="{span: 24}">
        <el-form-item :label="$l('form_label_name_cn')||'中文名称'" prop="resAttributeTypeName">
          <el-input
            v-model="formData.resAttributeTypeName"
            clearable
            size="medium"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="{span: 24}" :sm="{span: 24}" :md="{span: 24}" :lg="{span: 24}">
        <el-form-item :label="$l('form_label_name_en')||'英文名称'" prop="resAttributeTypeNameEn">
          <el-input
            v-model="formData.resAttributeTypeNameEn"
            clearable
            size="medium"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  props: {
  },
  data() {
    return {
      disabled: false,
      formData: {
        resAttributeTypeCode: "",
        resAttributeType: "",
        resAttributeStatus: "Y",
        resAttributeTypeName: "",
        resAttributeTypeNameEn: ""
      },
      rules: {
          resAttributeType: [
            { required: true, message: this.$l("form_rule_message_attribute_type") || "请输入属性类型", trigger: "blur" }
        ],
          resAttributeTypeName: [
          { required: true, message: this.$l("form_rule_message_attribute_name") || "请输入中文名称", trigger: "blur" }
        ],
          resAttributeTypeNameEn: [
            { required: true, message: this.$l("form_rule_message_attribute_name_en") || "请输入英文名称", trigger: "blur" }
        ]
      }
    }
  },
  methods: {
    // 加载表单数据（新增，编辑，详情）
    fromLoad(ref, val = "") {
      this.init();
      if (ref !== "add") {
        // 控制组件不可编辑
        if (ref === "detail") {
          this.disabled = true;
        }
        if (ref === "edit") {
          this.disabled = false;
        }
      }
    },
    // 保存数据
    save() {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.saveResearchDictionaryTypeApi(this.formData).then(() => {
            this.$message.success(this.$l("INDEX.tips_save_ok") || "保存成功");
            // 通知父组件保存成功
            this.$emit("success");
          });
        } else {
          return false;
        }
      });
    },
    // 初始化表单数据
    init() {
      this.disabled = false;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
        this.formData = {
          resAttributeTypeCode: "",
          resAttributeType: "",
          resAttributeStatus: "Y",
          resAttributeTypeName: "",
          resAttributeTypeNameEn: ""
        }
      }
    },
  },
};
</script>
